import React from 'react'
import {useSelector} from 'react-redux'
import Loading from '../otros/Loading'
import { useNavigate } from 'react-router-dom'

const SupervisorRoute = ({Component}) =>{
    const {user} = useSelector((state) => ({...state}))
    let navigate = useNavigate ()

    return user && user.token && user.rol === 'Supervisor' ? 
    (
    <Component/>
    ) : (
        navigate('/')
    )
}


export default SupervisorRoute